import { useCallback } from 'react';

export function useDefaultHandleEndReached(
  onEndReached?: () => void,
  isLoading?: boolean,
  hasNextPage?: boolean,
) {
  return useCallback(() => {
    if (onEndReached && !isLoading && hasNextPage) {
      onEndReached();
    }
  }, [onEndReached, isLoading, hasNextPage]);
}
